// removed by extract-text-webpack-plugin
module.exports = {"login-wrap":"login-wrap--1e3bm8","logo":"logo--15JOa0","title":"title--3G5g7V","container":"container--7ebj26","banner":"banner--2qMYls"};